import Button from "./Button";

/**
 * Each friend comp0nent in the friendslist component
 * @prop {Object} friend each friend object
 * @prop {Object} selectedFriend current selectedFriend object
 * @prop {Object} onSelection update the selectedFriend state with selected friend object and open up / close the split form.
 * @returns {JSX.Element}
 * @author Anik Paul
 */
export default function Friend({ friend, selectedFriend, onSelection }) {
  const isSelected = friend.id === selectedFriend?.id;

  return (
    <li className={isSelected ? "selected" : ""}>
      <img src={friend.image} alt={friend.name} />
      <h3>{friend.name}</h3>

      {friend.balance < 0 && (
        <p className="red">
          You owe {friend.name} {Math.abs(friend.balance)}€
        </p>
      )}
      {friend.balance > 0 && (
        <p className="green">
          {friend.name} owes you {Math.abs(friend.balance)}€
        </p>
      )}
      {friend.balance === 0 && <p>You and {friend.name} are even</p>}

      <Button onClick={() => onSelection(friend)}>
        {isSelected ? "Close" : "Select"}
      </Button>
    </li>
  );
}
